import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // optional but recommended for alerts
import { PostAPI } from '../../../ApiServices/ApiServices'; // adjust import path to match your project

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const sendCode = async () => {
    // ✅ Basic validation
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    // ✅ API payload and URL
    const url = "/auth/doctor/forgot-password";
    const data = { email };

    try {
      await PostAPI({ url, data }, async (res) => {
        if (res?.success && res?.statusCode === 200) {
          toast.success(res?.message || "Verification code sent successfully");
          // ✅ Navigate to verification page on success
          navigate("/verificationcodesent");
        } else {
          toast.error(res?.message || "Failed to send code. Please try again.");
        }
      });
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
      console.error(error);
    }
  };

  const signIn = () => {
    navigate("/");
  };

  return (
    <div className="login-form container">
      <div className="right-content">
        <h4 className="form-head forgot-ps">Forgot Password ?</h4>
        <p className="wel-content">Enter your Email ID to reset it!</p>
      </div>

      <div className="form-box">
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter Email ID here"
              name="email"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" onClick={sendCode} className="mb-3">
            Send Code
          </Button>

          <Button variant="primary" onClick={signIn} className="back-sgin-btn">
            Back to Signin
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
